import React from "react";
import {
  Group,
  Text,
  UnstyledButton,
  createStyles,
  getStylesRef,
} from "@mantine/core";

import { IconSquarePlus } from "@tabler/icons-react";

import ClientIcon from "../../images/clientIcon.png";

const useStyles = createStyles((theme, {disabled}) => ({
  mybutton: {
    background: "var(--app-primary)",
    marginLeft: "8px",
    opacity: disabled ? 0.8 : 1,
    cursor: disabled ? "not-allowed" : "pointer",
    borderRadius : '.5rem',
    [`&:hover .${getStylesRef("btnIcon")}`]: {
      background: "color-mix(in srgb, var(--app-primary) 88%, #000)",
    },
  },
  bgColor:{
    background: "var(--app-surface) !important",
  },

  btnIcon: {
    ref: getStylesRef("btnIcon"),
    background: "var(--app-primary)",
    borderRadius: 5,
  },
  btnText: {
    ref: getStylesRef("btnText"),
  },
}));

const AddButton = ({ title, BtnIcon , onClick, disabled , bgLess}) => {
  const { classes } = useStyles({disabled});
  let mainClass = bgLess ? [classes.mybutton , classes.bgColor] : classes.mybutton; 
  return (
    <UnstyledButton
      id="add-new-facility"
      className={mainClass}
      sx={{
        border: bgLess ? "1px solid var(--app-border)" : "none",
        color: bgLess ? "var(--app-text)" : "var(--app-on-primary)",
        [`&:hover .${getStylesRef("btnText")}`]: {
          background: bgLess ? "var(--app-surface-2)" : "color-mix(in srgb, var(--app-primary) 88%, #000)",
        },
      }}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
    >
      <Group spacing={5} p={10} sx={{display:'flex',alignItems:'center'}} >
        {/* {title === "Add Client" ? (
          <img
            src={ClientIcon}
            width={39}
            style={{ margin: "0 -4px", padding: "4px" }}
            className={classes.btnIcon}
            alt="client"
          />
        ) : (
          <IconSquarePlus
            color="black"
            stroke={1}
            className={classes.btnIcon}
            size={50}
          />
        )} */}
        <div>
          {BtnIcon ? BtnIcon : false}
        </div>
        
        <Text
          sx={{
            fontFamily: "Inter",
            fontSize: 16,
            fontWeight: 500,
            color: bgLess ? "var(--app-text)" : "var(--app-on-primary)",
            borderTopRightRadius: 5,
            borderBottomRightRadius: 5,
            backgroundColor: bgLess ? "var(--app-surface)" : "var(--app-primary)",
          }}
          className={classes.btnText}
          // p={7}
          ml={0}
        >
          {title}
        </Text>
      </Group>
    </UnstyledButton>
  );
};

export default AddButton;
